import { render, staticRenderFns } from "./BaseInputSelectThin.vue?vue&type=template&id=5f41ac7f&scoped=true&"
import script from "./BaseInputSelectThin.vue?vue&type=script&lang=js&"
export * from "./BaseInputSelectThin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f41ac7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
